import React from "react";
import {
  InputGroup as ReactstrapInputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { Trans } from "react-i18next";
import classNames from "classnames";

export const InputGroup = ({
  children,
  prefixIcon,
  suffixIcon,
  suffixText,
  ...props
}) => (
  <ReactstrapInputGroup {...props}>
    {!!prefixIcon && (
      <InputGroupAddon addonType="prepend">
        <InputGroupText>
          <span className={classNames("fa", prefixIcon)} />
        </InputGroupText>
      </InputGroupAddon>
    )}
    {children}
    {!!suffixIcon && (
      <InputGroupAddon addonType="append">
        <InputGroupText>
          <span className={classNames("fa", suffixIcon)} />
        </InputGroupText>
      </InputGroupAddon>
    )}
    {!!suffixText && (
      <InputGroupAddon addonType="append">
        <InputGroupText>
          <Trans>{suffixText}</Trans>
        </InputGroupText>
      </InputGroupAddon>
    )}
  </ReactstrapInputGroup>
);

export default InputGroup;
